module.exports = __webpack_public_path__ + "0b6e595ae48095f60c2941c0d40de3db.png";